import { render, staticRenderFns } from "./NewChatSelectedContacts.vue?vue&type=template&id=f783085e&scoped=true&"
import script from "./NewChatSelectedContacts.vue?vue&type=script&lang=js&"
export * from "./NewChatSelectedContacts.vue?vue&type=script&lang=js&"
import style0 from "./NewChatSelectedContacts.vue?vue&type=style&index=0&id=f783085e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f783085e",
  null
  
)

export default component.exports